'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/~/framework7-react/~/react/react.js
// module id = 32
// module chunks = 0